import useTranslator from "../../hooks/useTranslator";
import { ProgressRail, StepList } from "../../components/design";

/**
 * Left side of the "add a guarantor" pages (same look as the rental step).
 * mode: "choice" (how to continue), "provide" (you add their documents),
 * "send" (email them a request). `step` is the onboarding step number while
 * you add the documents.
 */
export default function GuarantorFlowRail({
  mode,
  step,
  language,
  guarantorName,
}) {
  const { _t } = useTranslator();

  const how = { id: "how", title: _t("guarantorHowToContinue") };
  const steps =
    mode === "send"
      ? [how, { id: "details", title: _t("guarantorDetails") }]
      : [
          how,
          { id: "details", title: _t("onboardingDetails") },
          { id: "identity", title: _t("onboardingIdentity") },
          { id: "documents", title: _t("onboardingDocuments") },
          { id: "financial", title: _t("onboardingFinancialStudy") },
        ];

  // Details(1) Identity(2) Documents(3-5) Financial(6)
  const provideIndex =
    step === 1 ? 1 : step === 2 ? 2 : step >= 3 && step <= 5 ? 3 : 4;
  const activeIndex =
    mode === "choice" ? 0 : mode === "send" ? 1 : provideIndex;

  return (
    <ProgressRail
      label={_t("guarantorProgress")}
      steps={steps}
      activeIndex={activeIndex}
      language={language}
    >
      <p className="onboarding-progress__eyebrow">
        {mode === "provide" && guarantorName
          ? _t("guarantorProfileEyebrow", "", undefined, {
              name: String(guarantorName).toUpperCase(),
            })
          : _t("addYourGuarantor")}
      </p>
      <StepList
        steps={steps}
        activeIndex={activeIndex}
        completedLabel={_t("completed")}
      />
    </ProgressRail>
  );
}
